import styled from "styled-components";

export const LogoBottom = styled.img`
	max-width: 50%;
	max-height: 15vh;
`